import type React from 'react';
import { memo } from 'react';
import { cn } from '@/lib/utils';
interface SoundEffectsProps extends React.SVGProps<SVGSVGElement> {}
const _SoundEffects = (props: SoundEffectsProps) => <svg aria-hidden="true" fill="none" height="16" viewBox="0 0 16 14" width="16" xmlns="http://www.w3.org/2000/svg" {...props} className={cn('size-4', props.className)} data-sentry-element="svg" data-sentry-component="_SoundEffects" data-sentry-source-file="SoundEffects.tsx">
    <path d="M14.5976 7.0359H12.7716C12.4422 7.0359 12.1616 6.79524 12.1122 6.46924L11.5829 4.3119C11.5176 3.51924 10.3682 3.48657 10.2582 4.27457L8.6429 12.4546C8.5349 13.2286 7.41223 13.2166 7.3209 12.4406L5.83756 1.6279C5.7449 0.840569 4.6009 0.844569 4.5129 1.6319L3.48556 7.0359H1.35156" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33" data-sentry-element="path" data-sentry-source-file="SoundEffects.tsx" />
  </svg>;
const SoundEffects = memo(_SoundEffects);
export const SoundEffectsWithIconTag = ({
  className
}: {
  className?: string;
}) => <i data-sentry-component="SoundEffectsWithIconTag" data-sentry-source-file="SoundEffects.tsx">
    <SoundEffects className={className} data-sentry-element="SoundEffects" data-sentry-source-file="SoundEffects.tsx" />
  </i>;
export default SoundEffects;